import { render, staticRenderFns } from "./PdfView.vue?vue&type=template&id=d213e2ec&scoped=true&"
import script from "./PdfView.vue?vue&type=script&lang=js&"
export * from "./PdfView.vue?vue&type=script&lang=js&"
import style0 from "./PdfView.vue?vue&type=style&index=0&id=d213e2ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d213e2ec",
  null
  
)

export default component.exports